// src/hooks/useContactForm.ts
import { useState, useEffect } from "react";
import { validateForm, FormData, FormErrors } from "../utils/validation";
import { addSupportRequest } from "../hooks/api-methods/useSupport";

export const useContactForm = (preFilledEmail = "") => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: preFilledEmail,
    tel: "",
    subject: "",
    message: "",
    to_name: "Decoratie Degezelle",
    privacyAgreement: false,
  });

  const [errors, setErrors] = useState<FormErrors>({});
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState<string | null>(null);
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement> | React.MouseEvent) => {
    e.preventDefault();
    setLoading(true);
    setFeedback(null);

    const validationErrors = validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      await addSupportRequest({
        name: formData.name,
        email: formData.email,
        phone: formData.tel,
        subject: formData.subject,
        note: formData.message,
        conditions: formData.privacyAgreement,
      });

      setFeedback("✅ Bedankt! Je bericht is verzonden.");
      setShowPopup(true);

      setFormData({
        name: "",
        email: preFilledEmail,
        tel: "",
        subject: "",
        message: "",
        to_name: "Decoratie Degezelle",
        privacyAgreement: false,
      });
    } catch (error: unknown) {
      if (error instanceof Error) {
        setFeedback(`❌ Fout bij verzenden: ${error.message}`);
      } else {
        setFeedback("❌ Fout bij verzenden: onbekende fout");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.body.style.overflow = showPopup ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPopup]);

  return {
    formData,
    errors,
    loading,
    feedback,
    showPopup,
    handleChange,
    handleSubmit,
    setShowPopup,
  };
};
